<form [formGroup]="holeForm" id="edge-custom-hole-form" novalidate>
  <mat-form-field appearance="outline" class="w-full dense-input" [ngClass]="{ hidden: !isFastenersSet(fastener) }">
    <mat-label i18n>Расположение</mat-label>
    <mat-select formControlName="type" (selectionChange)="setPlateTypeToSS($event.value)" required>
      <mat-option i18n [value]="thisFastenerPlateTypeEnum.Face">Лицевая сторона</mat-option>
      <mat-option i18n [value]="thisFastenerPlateTypeEnum.Back">Обратная сторона</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-full" [ngClass]="{ hidden: isFastenersSet(fastener) }">
    <mat-label i18n>Глубина</mat-label>
    <input i18n-placeholder formControlName="depth" matInput required type="number" cslSelectInputsByClick />
    <span *ngIf="!isFastenersSet(fastener)" matSuffix>mm (≥{{ fastener.minDepth }} ≤{{ fastener.maxDepth }})</span>

    <mat-error *ngIf="holeForm.controls.depth.invalid">
      {{ getError(holeForm.controls.depth.errors) | async }}
    </mat-error>
  </mat-form-field>
</form>

<div *ngIf="!isFastenersSet(fastener) && fastener.edgeHoleOffset !== 0">
  <span i18n>Отступ от лицевой стороны</span>: {{ fastener.edgeHoleOffset }}mm
</div>

<mat-divider> </mat-divider>

<csl-countertop-edge-hole-coordinates-form
  (formChanged)="holesCoordinatesFormChanged($event)"
  [maxHoleOffset]="maxHoleOffset"
  [coords]="data.coords"
  [side]="side || selectedMultiSide"
  [point]="point"></csl-countertop-edge-hole-coordinates-form>
